import { cn } from "@gigpro/ui/tailwind/cn";
import { Separator as SeparatorPrimitive } from "radix-ui";
import type * as React from "react";

const Separator = ({
  ref,
  className,
  orientation = "horizontal",
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) => (
  <SeparatorPrimitive.Root
    ref={ref}
    orientation={orientation}
    className={cn(
      "shrink-0 rounded-full bg-light-gray",
      orientation === "horizontal" ? "h-[2px] w-full" : "h-full w-[2px]",
      className,
    )}
    {...props}
  />
);
Separator.displayName = "Separator";

export { Separator };
